export const DEFAULT_LEGACY_TOPIC_ANALYTICS_MARKS_TALLY = {
  attemptedMarks: 0,
  inaccuracyMarks: 0,
  missedMarks: 0,
  sillyMarks: 0,
};

const analyticsAttributes = [
  'analytics',
  'calculationAnalytics',
  'extendedResponseAnalytics',
  'graphingAnalytics',
  'multipleChoiceAnalytics',
  'proofAnalytics',
  'shortAnswerAnalytics',
] as const;

const getAttributes = [
  'studentId',
  'subject',
  'topicId',
  'topicExams',
  ...analyticsAttributes,
] as const;

export const LegacyStudentTopicAnalyticsAttributes = {
  Get: getAttributes,
  Analytics: analyticsAttributes,
};
